module.exports = __webpack_public_path__ + "img/plus.71b8c061.svg";